<template>
  <div>
    <div class="page-title-box">
      <div class="page-title-right"></div>
      <h4 class="page-title">Arved</h4>
    </div>

    <div class="card">
      <div class="card-body bg-light pb-1">

        <b-form novalidate>
          <b-form-row>
            <div class="form-group col-6 col-lg-4 col-xl-2">
              <b-form-select v-model="filter.type" :options="types" size="sm" :class="{'form-control-highlighted': dirty('type')}"/>
            </div>
            <div class="form-group col-6 col-lg-4 col-xl-2">
              <b-form-select v-model="filter.status" :options="getStatuses(filter.type)" size="sm"
                             :class="{'form-control-highlighted': dirty('status')}"/>
            </div>
            <div class="form-group col-6 col-lg-4 col-xl-2">
              <b-form-select v-model="filter.numberPrefix" :options="numberPrefixes" value-field="code" text-field="label"
                             size="sm" :class="{'form-control-highlighted': dirty('numberPrefix')}"/>
            </div>
            <div class="form-group col-6 col-lg-4 col-xl-3">
              <date-range-picker v-model="filter.dateRange" placeholder="Ajavahemik"
                                 class="input-group-sm" :class="{'form-control-highlighted': dirtyDateRange()}"/>
            </div>
            <div class="form-group col-6 col-lg-4 col-xl-2">
              <div class="input-group input-group-sm input-group-prepend-icon input-group-append-icon">
                <span class="input-group-prependable-icon mdi mdi-magnify"></span>
                <input @change="onQueryChanged" :value="filter.query" placeholder="Otsingusõna"
                       class="form-control" :class="{'form-control-highlighted': dirty('query')}">
                <a v-if="!!filter.query" @click="clearQuery" class="input-group-appendable-icon mdi mdi-close"></a>
              </div>
            </div>
            <div class="form-group col-6 col-lg-4 col-xl-1 d-flex align-items-center justify-content-center">
              <a @click="resetFilter" class="reset-filter text-secondary"><span class="mdi mdi-filter-remove"></span> Algseis</a>
            </div>
          </b-form-row>
        </b-form>

      </div>
      <div class="card-body">
        <invoice-list :filter="filter"/>
      </div>
    </div>
  </div>
</template>

<script>
import InvoiceList from '../components/invoice/InvoiceList'
import ValidatedFormInput from '../components/ValidatedFormInput'
import DateRangePicker from '../components/DateRangePicker'
import SearchFilterMixin from '../mixins/SearchFilterMixin'

export default {
  mixins: [SearchFilterMixin],
  components: {InvoiceList, ValidatedFormInput, DateRangePicker},
  data() {
    return {
      defaultFilter: {
        type: 'normal',
        status: null,
        clientId: null,
        numberPrefix: null,
        query: null
      },
      filterPreviousState: this.$store.state.invoiceFilter,
      filter: {},
      types: [{value: 'normal', text: 'Arve (A)'}, {value: 'credit', text: 'Kreedit (K)'}, {
        value: 'advance',
        text: 'Ettemaks (E)'
      }, {value: null, text: 'Kõik tüübid'}],
      statuses: this.getStatuses(),
      numberPrefixes: [{code: null, label: 'Kõik objektid'}],
      invoices: null
    }
  },
  methods: {
    getStatuses(type) {
      if (type === 'advance') {
        this.filter.status = this.filter.status === 'paid' ? null : this.filter.status;
        return [{value: 'draft', text: 'Mustand'},
          {value: 'confirmed', text: 'Kinnitatud'},
          {value: null, text: 'Kõik staatused'}]
      }
      return [{value: 'draft', text: 'Mustand'},
        {value: 'confirmed', text: 'Maksmata'},
        {value: 'paid', text: 'Makstud'},
        {value: null, text: 'Kõik staatused'}];
    },
    clientChanged() {
      const client = this.$store.state.client || {id: null};
      this.filter.clientId = client.id
    },
    onQueryChanged(e) {
      this.filter.query = e.target.value === '' ? null : e.target.value
        if (this.filter.query) {
          this.filter.type = null
          this.filter.status = null
        }
      },
      clearQuery() {
        this.filter.query = null
      },
    },
    watch: {
      filter: {
        handler(filter) {
          this.$store.commit('invoiceFilter', filter)
        },
        deep: true
      }
    },
    created() {
      this.clientChanged()
      this.$gateway.get('/configuration/invoice-prefixes').then(r => {
        this.numberPrefixes.splice(0, 0, ...r.data)
      })
    }
  }
</script>
